import { Select } from '@mantine/core';
import { useList } from '../api/hooks/useCrud.ts';
import type { Country } from '../api/schemas/entities.ts';

/**
 * Country picker that stores the COUNTRY NAME as a string. Used for the
 * Nationality field on a Visitor (which the legacy schema stores as a free
 * string — distinct from `countryId`, which is a FK to the Country table
 * and tracks the visitor's country of residence).
 *
 * Options are sourced from the same /api/countries list as <CountrySelect>
 * but the value is the `name`, not the `id`, so changes here don't
 * accidentally mutate the residence country and vice versa.
 */
export function NationalitySelect({
  value,
  onChange,
  label,
  placeholder,
  required,
}: {
  value: string | null | undefined;
  onChange: (name: string | null) => void;
  label?: string;
  placeholder?: string;
  required?: boolean;
}) {
  const { data } = useList<Country>('countries');
  const options = (data ?? [])
    .filter(c => c.name && c.name.trim() !== '')
    .map(c => ({ value: c.name as string, label: c.name as string }));
  return (
    <Select
      label={label}
      placeholder={placeholder}
      data={options}
      value={value && value.trim() !== '' ? value : null}
      onChange={onChange}
      searchable
      clearable
      required={required}
    />
  );
}
